/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateCart} from '../api'

export const useMutationUpdateCart = createReactQueryMutationHook('updateCart', updateCart)
